import { NgModule } from "@angular/core";
import { SignInComponent } from './sign-in.component';
import { SharedModule } from "@partner/shared/shared.module";
import { SignInRoutingModule } from "./sign-in-routing.module";
import { SignInModule as CommonSignInModule } from 'common';

@NgModule({
  imports: [SharedModule, SignInRoutingModule, CommonSignInModule],
  declarations: [SignInComponent],
})
export class SignInModule { }
